module.exports = __webpack_public_path__ + "img/serviceResponsibleBonuse.03b67af1.svg";